module.exports = __webpack_public_path__ + "static/media/icon-sunrise.97fdadc9.svg";